function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import { arrayOf, bool, func, number, oneOf, shape, string } from 'prop-types';
import { debounce } from 'debounce';
import classnames from 'classnames';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { Logo } from "../../elements/Logo";
import { getNavigationItemsWidth } from "./utils/getNavigationItemsWidth";
import { getMenuWidth } from "./utils/getMenuWidth";
import { getIsMenuHidden } from "./utils/getIsMenuHidden";
import { getStandardMenuMarkup } from "./utils/getStandardMenuMarkup";
import { HiddenMenu } from "./components/HiddenMenu";
import { getLogoWidth } from "./utils/getLogoWidth";
import { MEDIUM_LOGO_SIZE } from "./constants";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeNavigationItemIndex: null,
      isMenuHidden: false,
      isOpaque: false,
      navigationItemsWidth: null,
      windowInnerWidth: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      global.window.addEventListener('resize', debounce(_this.handleResize, 150));

      _this.handleResize();

      _this.setState({
        activeNavigationItemIndex: _this.props.activeNavigationItemIndex,
        navigationItemsWidth: getNavigationItemsWidth(_this.header),
        isOpaque: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      if (previousState.windowInnerWidth !== _this.state.windowInnerWidth) {
        var menuWidth = getMenuWidth(_this.header);
        var logoWidth = getLogoWidth(_this.header);

        _this.setState({
          isMenuHidden: getIsMenuHidden(menuWidth, _this.state.navigationItemsWidth, logoWidth)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createHeaderRef", function (header) {
      return _this.header = header;
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (event) {
      _this.setState({
        windowInnerWidth: event && event.target.innerWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          isBackgroundFilled = _this$props.isBackgroundFilled,
          logoHref = _this$props.logoHref,
          logoSizes = _this$props.logoSizes,
          logoSize = _this$props.logoSize,
          logoSrc = _this$props.logoSrc,
          logoSrcSet = _this$props.logoSrcSet,
          logoSubText = _this$props.logoSubText,
          logoText = _this$props.logoText;
      var _this$state = _this.state,
          activeNavigationItemIndex = _this$state.activeNavigationItemIndex,
          isMenuHidden = _this$state.isMenuHidden,
          isOpaque = _this$state.isOpaque;
      return React.createElement("header", {
        className: classnames(className, {
          'is-background-filled': isBackgroundFilled,
          'is-opaque': isOpaque
        }),
        ref: _this.createHeaderRef
      }, React.createElement(HorizontalGutters, {
        as: Menu,
        borderless: true,
        text: true
      }, React.createElement(Logo, {
        logoHref: logoHref,
        logoSize: logoSize,
        logoSizes: logoSizes,
        logoSrc: logoSrc,
        logoSrcSet: logoSrcSet,
        logoSubText: logoSubText,
        logoText: logoText
      }), React.createElement(Menu.Menu, {
        position: "right"
      }, isMenuHidden ? React.createElement(HiddenMenu, _extends({}, _this.props, {
        activeNavigationItemIndex: activeNavigationItemIndex
      })) : getStandardMenuMarkup(_this.props, activeNavigationItemIndex))));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'Header';
Component.defaultProps = {
  activeNavigationItemIndex: null,
  className: '',
  isBackgroundFilled: false,
  logoHref: '/',
  logoSize: MEDIUM_LOGO_SIZE,
  logoSizes: undefined,
  logoSrc: null,
  logoSrcSet: undefined,
  logoSubText: null,
  primaryCTA: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activeNavigationItemIndex: number,
  className: string,
  isBackgroundFilled: bool,
  logoHref: string,
  logoSize: oneOf(['medium', 'large', 'huge']),
  logoSizes: string,
  logoSrc: string,
  logoSrcSet: string,
  logoSubText: string,
  logoText: string.isRequired,
  navigationItems: arrayOf(shape({
    href: string,
    subItems: arrayOf(shape({
      href: string.isRequired,
      target: string,
      text: string.isRequired
    })),
    target: string,
    text: string.isRequired
  })).isRequired,
  primaryCTA: shape({
    onClick: func.isRequired,
    text: string.isRequired
  })
} : {};